import React from "react";
import { AppShell } from "@/components/TopNav";
import { PageHeader } from "@/components/common";
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";
import { useBroker } from "@/pages/broker/useBroker";
import { BrokerStatusCard } from "@/components/broker/BrokerStatusCard";
import { BrokerOrderTicket } from "@/components/broker/BrokerOrderTicket";
import { BrokerBlotter } from "@/components/broker/BrokerBlotter";
import { ExchangeListingsDialog } from "@/components/broker/ExchangeListingsDialog";
import { ConnectDialog } from "@/components/broker/ConnectDialog";
import { ReviewOrderDialog } from "@/components/broker/ReviewOrderDialog";

// Thin orchestrator: all state/logic lives in the `useBroker` hook and the UI
// is composed from focused presentational components (status, order ticket,
// blotter and the three dialogs).
export default function Broker() {
  const b = useBroker();

  return (
    <AppShell>
      <PageHeader title="Global markets" subtitle="Order routing · global stocks & ETFs"
        testid="broker-header"
        action={<Button variant="secondary" className="gap-2" onClick={b.load} data-testid="broker-refresh"><RefreshCw className="h-4 w-4" /> Refresh</Button>} />

      <BrokerStatusCard b={b} />

      <div className="grid gap-6 lg:grid-cols-3">
        <BrokerOrderTicket b={b} />
        <BrokerBlotter b={b} />
      </div>

      <ExchangeListingsDialog b={b} />
      <ConnectDialog b={b} />
      <ReviewOrderDialog b={b} />
    </AppShell>
  );
}
